export default {
  show() {
    const preloader = document.createElement('div');
    const ganttWrapper = document.querySelector('.dhx_gantt_container');

    preloader.className = 'ganttPreloader';

    preloader.innerHTML = `<div class="webix_progress_icon_cover" aria-valuemin="0" aria-valuemax="100" tabindex="0">
        <div class="webix_progress_state " style="transition-duration: 2000ms; width: 100%;"></div>
    </div>`;

    ganttWrapper?.prepend(preloader);
  },
  hide() {
    const preloader = document.querySelector('.ganttPreloader');

    preloader?.remove();
  },
};
